import {ClientMessageRoomState} from "../store/client_message_room_state";
import {Reducer} from "redux";
import {
    ClientMessageRoomAction,
    ClientMessageRoomActionType,
    ICallbackCreateMessageRoomAction,
    ICallbackObserveMessageRoomAction,
} from "../action/client_message_room_action";
import {Message} from "../../domain/model/message";

const initialState: ClientMessageRoomState = {
    messageRoom: null,
    messages: [],
    project: null,
    ownSignature: null,
    opponentSignature: null,
    isLoading: false,
};

const clientMessageRoomReducer: Reducer<ClientMessageRoomState> = (state = initialState, action: ClientMessageRoomAction): ClientMessageRoomState => {
    switch (action.type) {
        case ClientMessageRoomActionType.REQUEST_CREATE_MESSAGE_ROOM: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientMessageRoomActionType.CALLBACK_CREATE_MESSAGE_ROOM: {
            const _action = action as ICallbackCreateMessageRoomAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    messageRoom: _action.item ? _action.item.messageRoom : null,
                    messages: _action.item ? _action.item.messages : [],
                    project: _action.item ? _action.item.project : null,
                    ownSignature: _action.item ? _action.item.ownSignature : null,
                    opponentSignature: _action.item ? _action.item.opponentSignature : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientMessageRoomActionType.CALLBACK_SEND_MESSAGE_ROOM: {
            if (action.isSuccess) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false
                });
            }
        }

        case ClientMessageRoomActionType.REQUEST_DESTROY_MESSAGE_ROOM: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientMessageRoomActionType.CALLBACK_DESTROY_MESSAGE_ROOM: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    messageRoom: initialState.messageRoom,
                    messages: initialState.messages,
                    project: initialState.project,
                    ownSignature: initialState.ownSignature,
                    opponentSignature: initialState.opponentSignature,
                    isLoading: initialState.isLoading,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        case ClientMessageRoomActionType.CALLBACK_OBSERVE_MESSAGE_ROOM: {
            const _action = action as ICallbackObserveMessageRoomAction;
            if (action.isSuccess) {
                const message: Message | undefined= (_action.item) ? _action.item.message : undefined;
                return Object.assign({}, state, {
                    messages: [...state.messages, message],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientMessageRoomReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_message_room_reducer.ts